import { routerMiddleware } from 'connected-react-router';
import DevTools from 'containers/DevTools/DevTools';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { logger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import createRootReducer from './createRootReducer';
import rootSaga from './rootSaga';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

const middlewares = [];
middlewares.push(routerMiddleware(history));
middlewares.push(sagaMiddleware);

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
  // middlewares.push(DevTools.instrument());
}

export const rootReducer = createRootReducer(history);

export const store = createStore(
  rootReducer,
  {},
  compose(
    applyMiddleware(...middlewares),
    DevTools.instrument()
  )
);

sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.ts